import { AnchorBasic, BREAKPOINT } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const SidebarTitle = styled.h1`
  font-size: 2rem;
  line-height: 1.1;
  margin: 0;
`

export const SidebarSubtitle = styled.h2`
  font-size: 1.125rem;
  line-height: 1.56;
  font-weight: 500;
  margin: 0;
  color: ${({ theme }) => theme.colors.BLUE_1000};
`

export const SidebarWrapper = styled.aside`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: none;

  background-color: ${({ theme }) => theme.colors.GREY_60};

  @media screen and (min-width: ${BREAKPOINT.SM}px) {
    overflow-y: scroll;
    height: 100vh;
  }

  @media screen and (min-width: ${BREAKPOINT.MD}px) {
    overflow-y: scroll;
    width: 376px;
    height: 100vh;
  }

  @media screen and (min-width: ${BREAKPOINT.LG}px) {
    width: 540px;
  }

  @media screen and (min-width: ${BREAKPOINT.XXL}px) {
    width: 580px;
  }
`

export const SidebarContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 35px 40px 0 40px;

  @media screen and (min-width: ${BREAKPOINT.SM}px) {
    margin: 214px 71px 0 71px;
  }
`

export const Anchor = styled(AnchorBasic)`
  ${({ theme }) => theme.typography['body-base']}
  font-size: 12px;
  line-height: 1.8;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.GREY_580};

  text-decoration: underline;
  width: fit-content;

  &:hover {
    text-decoration-color: ${({ theme }) => theme.colors.GREY_580};
  }
`
